import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createTextVNode("Confirmation")
const _hoisted_2 = {
  class: "px-16 df-col df-middle df-center",
  style: {"width":"100%"}
}
const _hoisted_3 = { class: "con-t df-middle df-center" }
const _hoisted_4 = /*#__PURE__*/_createTextVNode("per day")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_t = _resolveComponent("t")
  const _component_Pic = _resolveComponent("Pic")
  const _component_Button = _resolveComponent("Button")
  const _component_DialogTemplate = _resolveComponent("DialogTemplate")

  return (_openBlock(), _createBlock(_component_DialogTemplate, null, {
    title: _withCtx(() => [
      _createVNode(_component_t, { path: "cup_28" }, {
        default: _withCtx(() => [
          _hoisted_1
        ]),
        _: 1
      })
    ]),
    cancelText: _withCtx(() => [
      _createVNode(_component_t, {
        path: "cup_32",
        custom: ""
      }, {
        default: _withCtx(({td}) => [
          _createTextVNode(_toDisplayString(td || 'NO'), 1)
        ]),
        _: 1
      })
    ]),
    confirm: _withCtx(() => [
      _createVNode(_component_Button, {
        class: "flex-1 btn primary",
        progress: _ctx.progress,
        onClick: _ctx.open
      }, {
        default: _withCtx(() => [
          _createVNode(_component_t, {
            path: "cup_33",
            custom: ""
          }, {
            default: _withCtx(({td}) => [
              _createTextVNode(_toDisplayString(td || 'YES'), 1)
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["progress", "onClick"])
    ]),
    default: _withCtx(() => [
      _createVNode("div", _hoisted_2, [
        _createVNode("div", _hoisted_3, [
          _createVNode(_component_Pic, {
            src: "cup/wt/coupon",
            width: "56",
            height: "56"
          }),
          _createVNode(_component_t, {
            class: "f-bold ml-8",
            path: "cup_29"
          }, {
            default: _withCtx(() => [
              _hoisted_4
            ]),
            _: 1
          })
        ]),
        _createVNode(_component_t, {
          class: "mt-16 pb-32",
          path: _ctx.context
        }, null, 8, ["path"])
      ])
    ]),
    _: 1
  }))
}